
const LineDataAPI = (response) => {

    const datosLine = []
    const uniqueArray = []
    const uniqueSeries = []
    const uniqueColors = []

    //Obtendo los array con las series y los colores. Solo 1 registro por serie y por color (uniqueSeries y uniqueColors)
    response.data.map(item => {
        var findItem = uniqueArray.find(x => x.serie === item.serie);
        if (!findItem) {
            uniqueArray.push(item);
            uniqueSeries.push(item.serie);
            uniqueColors.push(item.color);
        }
    });

    // recorro el array con las distintas series y luego recorro los datos del API para crear el array datosSeries
    uniqueSeries.map((f, j) => {
        const datosSerie = []
        for (let index = 0; index < response.data.length; index++) {
            const element = response.data[index];
            if (element.serie == uniqueSeries[j])
                datosSerie.push([parseFloat(element.x), element.y])
        }

        datosLine.push(
            {
                datos: datosSerie,
                color: uniqueColors[j],
                name: uniqueSeries[j]
            }
        )
    }
    )

    return datosLine
}

export default LineDataAPI




